import { createFileRoute } from "@tanstack/react-router";
import { Shell } from "@/components/control-tower/Layout";
import { TrendView } from "@/components/building/trend/TrendView";
import { useInventoryFilter } from "@/lib/inventory-filter";
import { useDashboardStats } from "@/lib/api/useDashboardStats";
import { useFilteredBuildings } from "@/lib/inventory-scope";

export const Route = createFileRoute("/trend")({
  component: TrendPage,
});

// Trendi — the historical/predictive signal explorer as a scope-aware Toiminto,
// not a perspective and not embedded in Analyysi or Kaksonen. Scope comes from the
// shared ScopeBar: a single building renders its history directly; Kiinteistösalkku/-kanta scope
// resolves the candidate building set with the same useFilteredBuildings helper
// Energiatehokkuus/Aktiviteetti already use. TrendView drives its own kind → type → signal picker
// (#1220/#1224) and overlays series — per-instance, capped, scope-aware, never a per-building
// representative — on unit-grouped panels (#1191).
function TrendPage() {
  const { buildingId } = useInventoryFilter();
  const stats = useDashboardStats();
  const candidateBuildings = useFilteredBuildings(
    stats.status === "ok" ? stats.buildings : [],
  );

  return (
    <Shell title="Trendi" subtitle="Signaalihistoria ja ennusteet">
      <TrendView
        buildingId={buildingId}
        candidateBuildings={candidateBuildings}
      />
    </Shell>
  );
}
